import { Box, Container, Skeleton } from "@mui/material";
export default function CDSkeleton() {
  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default", py: 4 }}>
      <Container maxWidth="xl">
        <Skeleton variant="text" width={200} height={40} sx={{ mb: 3 }} />
        <Box
          sx={{
            display: "flex",
            gap: 3,
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <Skeleton
            variant="rectangular"
            width={320}
            height={500}
            sx={{ borderRadius: 4 }}
          />
          <Box
            sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}
          >
            <Skeleton
              variant="rectangular"
              height={300}
              sx={{ borderRadius: 4 }}
            />
            <Skeleton
              variant="rectangular"
              height={200}
              sx={{ borderRadius: 4 }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
